import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";
import Variables from "../variables/variables.json";
import { useMemo } from "react";
import { resolveArticleAuthor } from "../lib/authors";

export default function SEO(props) {
	const router = useRouter();
	const intl = useIntl();

	const hostName = "https://przyjazne-deklaracje.pl";
	const routerUrl = (router.asPath || "/").split("?")[0].split("#")[0];
	const routerLocale = router.locale;
	const RouterRedirect = props.routerRedirect;

	const resolvedArticleAuthor = props.blog
		? resolveArticleAuthor({
				authorId: props.authorId,
				authorVariable: props.authorVariable,
				author: props.author,
		  })
		: null;

	let Miasto;
	let Podatek;

	let miastoJSON;
	let witryna;
	let heroImg;

	if (!props.blog) {
		Miasto = props.miasto;
		Podatek = props.podatek;

		miastoJSON = Variables.miasta[Miasto];

		if (!miastoJSON) {
			return null;
		}

		witryna = miastoJSON.witryna;
		heroImg = miastoJSON.slider?.[Podatek]?.header?.images;
	}

	const canonicalUrl = props.canonical || `${hostName}${routerUrl}`;

	const dateISO8601 =
		props.datePublication && props.hours
			? `${props.datePublication}T${props.hours}Z`
			: undefined;

	const seoTitle = useMemo(() => {
		if (props.seoTitle) {
			return props.seoTitle;
		}

		if (props.blog) {
			return props.seoTitle || "";
		}

		return intl.formatMessage({
			id: "miasta." + Miasto + ".SEO." + Podatek + ".title",
		});
	}, [props.blog, props.seoTitle, intl, Miasto, Podatek]);

	const seoDescription = useMemo(() => {
		if (props.seoDescription) {
			return props.seoDescription;
		}

		if (props.blog) {
			return props.seoDescription || "";
		}

		return intl.formatMessage({
			id: "miasta." + Miasto + ".SEO." + Podatek + ".description",
		});
	}, [props.blog, props.seoDescription, intl, Miasto, Podatek]);

	const siteName = useMemo(() => {
		if (props.blog) {
			return "Przyjazne Deklaracje";
		}

		return intl.formatMessage({
			id: "miasta." + Miasto + ".siteName",
		});
	}, [props.blog, intl, Miasto]);

	return (
		<>
			{props.blog ? (
				<NextSeo
					title={seoTitle}
					description={seoDescription}
					canonical={canonicalUrl}
					openGraph={{
						site_name: siteName,
						type: "article",
						locale: routerLocale,
						url: canonicalUrl,
						title: seoTitle,
						description: seoDescription,
						images: props.imagesUrl
							? [
									{
										url: props.imagesUrl,
									},
							  ]
							: [],
						article: {
							authors: resolvedArticleAuthor?.url ? [resolvedArticleAuthor.url] : [],
							publishedTime: dateISO8601,
						},
					}}
					noindex={false}
					nofollow={false}
				/>
			) : (
				<NextSeo
					title={seoTitle}
					description={seoDescription}
					canonical={canonicalUrl}
					openGraph={{
						site_name: siteName,
						type: "website",
						locale: routerLocale,
						url: witryna && RouterRedirect ? hostName + RouterRedirect : canonicalUrl,
						title: seoTitle,
						description: seoDescription,
						images: heroImg?.mobile
							? [
									{
										url: heroImg.mobile,
									},
							  ]
							: [],
					}}
					noindex={Variables.miasta[Miasto].test}
					nofollow={Variables.miasta[Miasto].test}
				/>
			)}
		</>
	);
}